import { NEW_PROFILE_DOCTOR, NEW_PROFILE_FACILITY, NEW_PROFILE_INDUSTRY } from "../constants/RoutesUrl";

/**
 * Returns the correct profile route based on user_type.
 * @param {object} user - user object with id and user_type
 * @returns {string} route path
 */
export const getProfileRoute = (user) => {
  const id = user?.user_id || user?.id;
  if (!id) return "/feed";
  const type = (user?.user_type || user?.type || "").toLowerCase();
  if (type === "facility" || type === "hospital") return `${NEW_PROFILE_FACILITY}/${id}`;
  if (type === "industry" || type === "company") return `${NEW_PROFILE_INDUSTRY}/${id}`;
  return `${NEW_PROFILE_DOCTOR}/${id}`;
};

/**
 * Returns a smart subtitle/designation for any user (Doctor, Facility, Industry).
 * @param {object} user - user object
 * @param {object} lang - language translation dictionary
 * @returns {string} subtitle
 */
export const getUserSubtitle = (user, lang) => {
  if (!user) return "";
  const userType = (user.user_type || user.type || "").toLowerCase();

  // 1. Explicit specialization
  if (user.specialization) return user.specialization;
  if (Array.isArray(user.specializations) && user.specializations.length > 0) {
    return user.specializations.map((s) => s.name || s).join(", ");
  }

  // 2. Specific Sub-type (e.g., "Hospital", "Pharma", "Clinic", "Equipment")
  if (user.sub_type) return user.sub_type;

  // 3. User Title (e.g., "Ophthalmologist", "Eye Surgeon")
  if (user.user_title) return user.user_title;

  // 4. Industry category
  if (user.category) return user.category;

  // 5. Designation / Role
  if (user.designation) return user.designation;

  // 6. Fallback based on user_type
  if (userType === "facility" || userType === "hospital") return lang?.facility || "Facility";
  if (userType === "industry" || userType === "company") return lang?.industry || "Industry";
  if (userType === "doctor") return lang?.doctor || "Doctor";

  return user.user_name || lang?.doctor || "Doctor";
};

/**
 * Navigates to the correct profile page based on user_type.
 * @param {object} user - user object with id and user_type
 * @param {function} navigate - react-router navigate function
 */
export const navigateToProfile = (user, navigate) => {
  navigate(getProfileRoute(user));
};
